import { Component, OnInit, ViewChild, Compiler } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import {MatTableDataSource, MatPaginator, MatSort,} from '@angular/material';
import * as $ from 'jquery';

var COMP = environment.component.gender;
export interface Element {
    column1: string;
    column2: string;
    column3: string;
    column4: string;
    column5: string;
    column6: string;
    column7: string;
    column8: string;
  }

  const ELEMENT_DATA: Element[] =[
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "1j",
       column6: "Yes",
       column7: "Water Governance: The presence and nature of gender-specific  objectives and commitments  (or gender strategy) in national- and sector-level water policies.",
       column8: "> Are specific gender objectives articulated within all key national policies and strategies for this target/indicator?",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "1k",
       column6: "No",
       column7: "Water Governance: The nature and extent of sex-disaggregated data related to water and sanitation collected by responsible public entities at national and local levels (in relation to the totality of social indicators on water and sanitation collected).",
       column8: "",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "1i",
       column6: "No",
       column7: "Water Governance: The extent to which gender outcomes and gender-sensitive accountability indicators are included in M&E/impact statements/benefits  analyses of national-level  water-sector  projects (project  proposals and/or  outcomes assessments). Sample projects.",
       column8: "",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "1h",
       column6: "Yes",
       column7: "Water Governance: Presence and nature of gender-sensitive  training  within  responsible ministries/lead agencies; Participation of M/F staff.",
       column8: ">Is there gender sensitivity training within lead Ministries/Institutions at least once a year?",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "1a",
       column6: "Yes",
       column7: "Water Governance: Number of male and female (M/F) paid staff in public water-governance agencies, disaggregated by job category/level and decision-making capacity (and salary, if available), at:- national level; county/state levels/ and town/village levels",
       column8: ">What are the proportions of female and male paid staff in the lead Ministry/Agency for this target/indicator, disaggregated by job category/level and decision-making capacity?",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "1e",
       column6: "No",
       column7: "Water Governance: Number of M/F staff responsible for water issues (disaggregated  by job level) in gender ministry/lead  agency.",
       column8: "",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "1f",
       column6: "Yes",
       column7: "Water Governance: Number of M/F staff responsible for gender issues (disaggregated  by job level) in lead agency for the water sector.",
       column8: ">How many staff are responsible for gender issues in the lead Ministry/ Agency for this target/indicator?",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "1b",
       column6: "No",
       column7: "Water Governance: Number of M/F in paid and unpaid  positions in local water governance formally-structured entities (water users associations, etc.) at town/village level (sample); disaggregated by nature of relationship to the entity (e.g. “member”, “board”, “executive”, “leadership,” decision-making group, etc.) and types of tasks.",
       column8: "",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "1d",
       column6: "No",
       column7: "Water Governance: M/F perceptions of gender discrimination (or equality) regarding women’s participation in decision-making entities.",
       column8: "",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "1c",
       column6: "Yes",
       column7: "Water Governance: Intensity of M/F participation  in (sample/representative) meetings of public entity bodies sampled at national, sub-national, and local levels, including outcomes such as: ratio of contributions  in decision-making meetings by women and men; percentage of decisions adopted from women’s contributions in meetings.",
       column8: ">What was the intensity of male and female participation in at least three national-level meetings of Government and public bodies for this target/indicator this year?",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "1g",
       column6: "Yes",
       column7: "Water Governance: Designated ministerial responsibility for gender in relation to water policies; the extent to which gender-specific agencies are included in water sector decision-making.",
       column8: ">How often are national gender agency specialists  included in decision-making for this target/indicator?",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "4c",
       column6: "No",
       column7: "Transboundary Water Management: The presence and nature of gender-specific objectives and commitments (or gender strategy) in transboundary agreements.",
       column8: "",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "4b",
       column6: "No",
       column7: "Transboundary Water Management: The extent to which gender outcomes and gender-sensitive accountability indicators are included in M&E/impact statements/benefits analyses of transboundary agreements/activities.",
       column8: "",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "4a",
       column6: "No",
       column7: "Transboundary Water Management: Number of M/F staff on transboundary water commissions (sample for pilot countries), disaggregated by job category/level and decision-making capacity (and salary, if available)",
       column8: "",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "4d",
       column6: "No",
       column7: "Transboundary Water Management: Intensity of M/F participation in (sample/representative) meetings of transboundary meetings, including outcomes such as: ratio of contributions in decision-making meetings by women and men; percentage of decisions adopted from women’s contributions in meetings.",
       column8: "",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "",
       column6: "No",
       column7: "Strengthening the voice of men and women: Ratio of contributions in decision making meetings by women and men",
       column8: "Are sector meetings at community level organized to overcome cultural barriers to women’s participation, (cultural norms, seating arrangements, language and meeting times)?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "",
       column6: "No",
       column7: "Strengthening the voice of men and women: Ratio of contributions in decision making meetings by women and men",
       column8: "Do operational agencies provide information for decision making on policies, strategies, plans and investments, in a format that is user-friendly and accessible to women, marginalized groups and the organizations that represent them?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "",
       column6: "No",
       column7: "Strengthening the voice of men and women: Ratio of contributions in decision making meetings by women and men",
       column8: "Do policy makers and regulatory bodies make use of feedback mechanisms for complaints and challenges faced by citizens from their providers, including those on lower levels of service, such as for those relying on stand pipes and kiosks?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "",
       column6: "No",
       column7: "Strengthening the voice of men and women: Number of policies and strategies published with inputs from non-state actors and marginalized groups",
       column8: "Do service providers demonstrate commitment to the citizen voice by utilizing tools like citizens’ charters, ICT, satisfaction surveys, toll free lines and effective complaint desks?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "",
       column6: "No",
       column7: "Strengthening the voice of men and women: Number of policies and strategies published with inputs from non-state actors and marginalized groups",
       column8: "Is civil society supported in holding service providers and power holders accountable for their performance and behavior?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "",
       column6: "No",
       column7: "Strengthening the voice of men and women:  Number of policies and strategies published with inputs from non-state actors and marginalized groups",
       column8: "Do agencies allow citizens to influence their plans, budgets and strategies, based on the voices of both women and men?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "2.4",
       column6: "Yes",
       column7: "Mainstreaming gender in operations: The impact and effectiveness of activities to promote greater gender equality within the organizational culture of development groups e.g., the impact of affirmative action policies.",
       column8: "Is there an internal work place gender policy and strategy which takes cognizance of national and sector gender targets?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "2.4",
       column6: "No",
       column7: "Mainstreaming gender in operations: The impact and effectiveness of activities to promote greater gender equality within the organizational culture of development groups e.g., the impact of affirmative action policies.",
       column8: "Is capacity being built for staff to address gender issues in urban and rural water and sanitation programs?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "2.1",
       column6: "No",
       column7: "Mainstreaming gender in operations: The impact and effectiveness of activities to promote greater gender equality within the organizational culture of development groups e.g., the impact of affirmative action policies",
       column8: "Have urban and small utilities adopted services to the poor as a key corporate objective and employed gender trained staff to address the numerous gender issues in poorer areas?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "",
       column6: "No",
       column7: "Mainstreaming gender in operations: Percentage of men and women engaged in initiating, siting, implementing, using, and O&M of WSS",
       column8: "Is there a national strategy for sanitation in schools, with emphasis on safe, separate, well-maintained facilities for girls and boys?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "",
       column6: "No",
       column7: "Mainstreaming gender in operations: Percentage of men and women engaged in initiating, siting, implementing, using, and O&M of WSS",
       column8: "Is there equal participation of men and women at all stages: initiation, design, site location, implementation, price setting, O&M and management?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "",
       column6: "No",
       column7: "Mainstreaming gender in operations: Percentage increase in income for women and men from productive uses of water",
       column8: "Are there equal economic opportunities from WSS interventions?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "2.3",
       column6: "Yes",
       column7: "Mainstreaming gender in operations:  The impact and effectiveness of activities to promote greater gender equality within the organizational culture of development groups e.g., the impact of affirmative action policies.",
       column8: "Are performance-based contracts or similar boundaries in place to compel staff to pursue gender mainstreaming objectives and incentives to reward them for doing so?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "",
       column6: "No",
       column7: "Mainstreaming gender in operations:  Percentage of men and women engaged in initiating, siting, implementing, using, and O&M of WSS",
       column8: "Do implementation and communication strategies inform women and men how to participate equitably in all phases of the WSS cycle?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "1.1",
       column6: "No",
       column7: "Mainstreaming gender at policy level: Water and sanitation equity distribution ratios and percentage of population on-network vs. off-network",
       column8: "Does sector policy address barriers facing both men and women in making productive use of water e.g. for household, livestock, drip irrigation or cottage industries?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "1.8",
       column6: "Yes",
       column7: "Mainstreaming gender at policy level: The existence of gender specific objectives within national and sector level policies.",
       column8: "Has gender analysis been undertaken to inform national policy responses to gender issues in the water and sanitation sector at country level?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "1.5",
       column6: "Yes",
       column7: "Mainstreaming gender at policy level: The existence of gender specific objectives within national and sector level policies.",
       column8: "Are specific gender objectives articulated within national water and sanitation policies and strategies?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "1.4",
       column6: "Yes",
       column7: "Mainstreaming gender at policy level: The existence of gender specific objectives within national and sector level policies.",
       column8: "Do policies address issues in women’s participation and representation and target pockets of vulnerability to promote equity?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "1.7",
       column6: "Yes",
       column7: "Mainstreaming gender at policy level: The existence of gender policies within agencies involved in sector development.",
       column8: "Has an institutional audit been done to identify gaps in lead ministry capacity and practice, in responding to gender issues?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "1.2",
       column6: "Yes",
       column7: "Mainstreaming gender at policy level: The existence of gender policies within agencies involved in sector development.",
       column8: "Do the lead water and sanitation sector ministries and its appointed agencies allocate resources for gender mainstreaming activities?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "1.1",
       column6: "Yes",
       column7: "Mainstreaming gender at policy level: The existence of gender policies within agencies involved in sector development.",
       column8: "Do sector agencies operating at the national level, have gender policies to align and inform their investment and do they support national government to fulfill mainstreaming policy goals?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "1.3",
       column6: "Yes",
       column7: "Mainstreaming gender at policy level: The existence of gender policies within agencies involved in sector development.",
       column8: "Do national level stakeholders (government, donors, civil society, research agencies) regularly incorporate gender considerations in studies, reviews or research commissioned to progress sector goals?",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "3d",
       column6: "No",
       column7: "Decision-Making and Knowledge production: M/F perceptions of/knowledge  of current total household use of water, by category of use and by primary user.",
       column8: "",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "3g",
       column6: "No",
       column7: "Decision-Making and Knowledge production: M/F perceptions of household gender equality in water decisions",
       column8: "",

    },
    {
       column1: ">",
       column2: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column3: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column4: "None found",
       column5: "None",
       column6: "3a",
       column7: "No",
       column8: "Decision-Making and Knowledge production: M/F participation  in past decade of two major global international water meetings (and nationally-significant  comparable meetings):• World Water Week (Stockholm)• World Water Forum (World Water Council)",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "3b",
       column6: "Yes",
       column7: "Decision-Making and Knowledge production: M/F inclusion on nationally and internationally  convened scientific panels and advisory boards",
       column8: "What is the proportion of female and male representation on all national and international scientific or advisory boards that exist for this target/indicator?",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "3f",
       column6: "No",
       column7: "Decision-Making and Knowledge production: M/F expressed priorities  for water use within households.",
       column8: "",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "3e",
       column6: "No",
       column7: "Decision-Making and Knowledge production: Household member primarily responsible for managing the household water:\n• M/F perceptions of the nature of their household decision-making  process for water priorities and use;\n• M/F perceptions of the primary decision-maker  on water issues within  the household (if any); and\n• M/F perceptions of how intra-household conflicts related to water (if any) are resolved.",
       column8: "",

    },
    {
       column1: "Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting",
       column2: "http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf",
       column3: "None found",
       column4: "None",
       column5: "3c",
       column6: "No",
       column7: "Decision-Making and Knowledge production: Gender audit  of WHO/UNICEF JMP (could be topic specific or region specific).",
       column8: "",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "2.5",
       column6: "Yes",
       column7: "Mainstreaming gender in operations: The impact and effectiveness of activities to promote greater gender equality within the organizational culture of development groups e.g., the impact of affirmative action policies.",
       column8: "Is there institutional awareness and commitment to promote equality in representation between women and men in the water agency; equal compensation for equal work, and equal opportunities for training?",

    },
    {
       column1: "World Bank Water and Sanitation Programme Gender Checklist",
       column2: "https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf",
       column3: "None found",
       column4: "None",
       column5: "2.2",
       column6: "Yes",
       column7: "Mainstreaming gender in operations: The impact and effectiveness of activities to develop gender awareness and skills amongst policy-making, management and implementation staff.",
       column8: "Are resources allocated to implement gender strategies (e.g. participatory approaches, gender assessments, specially targeted projects) within agency service activities?",

    }
   ];

@Component({
  selector: 'app-gender',
  templateUrl: './gender.component.html',
  styleUrls: ['./gender.component.css']
})
export class GenderComponent implements OnInit {

//@ViewChild(MatPaginator) paginator: MatPaginator;
@ViewChild(MatSort) sort: MatSort;

  displayedColumns = ['column1', 'column2', 'column3', 'column4', 'column5', 'column6', 'column7', 'column8'];
  dataSource: MatTableDataSource<Element>;

  constructor(private router: Router, private _compiler: Compiler) {
    this.dataSource = new MatTableDataSource(ELEMENT_DATA);
   }

  ngOnInit() {
    this._compiler.clearCache();
    $(".header_active").removeClass("header_active")
    $(".gender-click").addClass("header_active")
  }
  ngAfterViewInit() {
    //this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
    addQuestion(){
        this.router.navigateByUrl('/sdg/add-question/'+COMP)
    }
    homeBtnClick(){
        this.router.navigateByUrl('/sdg/sdg-home')
    }
    quesBtnClick(){
        this.router.navigateByUrl('/sdg/gender-quest')
    }
    dataBtnClick(){
        this.router.navigateByUrl('/sdg/gender-data')
    }
    reportBtnClick(){
        this.router.navigateByUrl('/sdg/gender-report')
    }
}



// WEBPACK FOOTER //
// ./src/app/sdg/gender/gender.component.ts